/*
🚨 @customScript.js is a custom script file that is automatically loaded by the theme. It is designed to be used for storing custom JavaScript functions and configurations.

The Impact Theme includes documentation located here: https://support.maestrooo.com/category/300-technical-documentation
*/


$(document).ready(function () {

    /* Function: tabs */
    $('.tab').click(function () {
        var tabId = $(this).data('tab');
        $(this).addClass('active').siblings().removeClass('active');
        $('#content-' + tabId).addClass('active').siblings('.content').removeClass('active');
    });

    /* END Function: tabs */

    $('.shopify-section--main-product').ifExists(function () { // Runs on the main product page
        var elm = '.thumbsCustomBlock';
        var initial_variant = document.querySelector('[name="id"]').value;
        var initial_index = parseInt($('.product-gallery__media-list').attr('initial-index') || 0);

        var glide = new Glide(elm, {
            type: 'slider',
            perView: 5,
            gap: 15,
            loop: false,
            startAt: initial_index,
        });

        function goToSlide(variant) {
            const selectedIndex = variant.featured_media.position - 4;
            glide.go(`=${selectedIndex}`);
        }

        glide.mount(initial_variant);
        console.log(initial_variant)
        document.addEventListener('variant:change', function (event) { // Product event scope: https://support.maestrooo.com/article/304-technical-javascript-events-exposed-by-the-theme
            goToSlide(event.detail.variant)
        });
    });



});


$.fn.ifExists = function (callback) { // Check if element exists
    if (this.length > 0 && typeof callback === 'function') {
        callback.call(this);
    }
    return this;
};

